import mainCaller from './mainCaller';
import { deleteConsultation } from './consultation';
import { deleteBranchSchedule } from './branchSchedule';

// 스케줄 카드 우클릭 '일정 삭제' API — 백엔드 경로가 확정되지 않아 이 파일 한 곳에 모은다.
// 수업은 courseClassId 기준(/course/classes/{id}), 상담·기타는 기존 삭제 API 를 그대로 쓴다.

/** 수업 삭제 대상 id — 경로의 {id} 가 바뀌면 여기만 고친다 */
export const classDeleteIdOf = event => event?.courseClassId;

// GET /admin/api/v1/course/classes/{id}/delete-preview
// → { classType, classDate, startTime, endTime, trainerName, reservedCount, waitingCount, attendedCount, absentCount, restorableUsage }
export const getClassDeletePreview = async (id, token) =>
  mainCaller(`admin/api/v1/course/classes/${id}/delete-preview`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });

// DELETE /admin/api/v1/course/classes/{id}/force?restoreUsage=true|false
export const forceDeleteClass = async (id, restoreUsage, token) =>
  mainCaller(`admin/api/v1/course/classes/${id}/force?restoreUsage=${restoreUsage ? 'true' : 'false'}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });

/** 상담·기타 일정 삭제 — 기존 API */
export const deleteNonClassSchedule = async (event, token) =>
  event.courseClassType === 'CONSULTATION'
    ? deleteConsultation(event.consultationId, token)
    : deleteBranchSchedule(event.branchScheduleId, token);
